import React from 'react';
import Shortcode, { ShortcodeProps } from 'components/Shortcode';
import { Colorway } from '@uds/theme-utils';
import { Alignment } from 'domain/constants/alignment';

import useStylesheet from './Cell.stylesheet';

export interface CellProps {
  body: ShortcodeProps;
  layout?: {
    alignment?: Alignment;
  };
}

export interface OuterProps {
  colorway: Colorway;
  cell: CellProps;
}

const PureCell = ({ colorway, cell }: OuterProps) => {
  const { styles } = useStylesheet({ cell });
  return (
    <div style={styles.root}>
      <If condition={Boolean(cell)}>
        <Shortcode against={colorway} code={cell.body} />
      </If>
    </div>
  );
};

PureCell.displayName = 'Cell';

export default PureCell;
